module.exports = __webpack_public_path__ + "static/img/mirrorImg2.10d75c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mirrorImg2.png
// module id = ZRlX
// module chunks = 2